import React from 'react'

function FormInfoTip ({ title = 'Info', children, className = '' }) {
  return (
    <details className={`form-info-tip ${className}`.trim()}>
      <summary
        className='form-info-tip__trigger'
        aria-label={title}
        title={title}
      >
        <i className='bi bi-info-circle'></i>
      </summary>
      <div className='form-info-tip__panel' role='note'>
        {title ? <strong className='form-info-tip__title'>{title}</strong> : null}
        <div className='form-info-tip__body'>{children}</div>
      </div>
    </details>
  )
}

export default FormInfoTip
